// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3NOpN","header":"MessagesList_header__2biwc","chat":"MessagesList_chat__3X4BL"};